import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

interface InShellStatusProps {
  title: string;
  /** The explanation, as a sentence or two. */
  children: ReactNode;
  action?: ReactNode;
}

/**
 * A status message in the shell's content area: the header and drawer stay.
 * For states that replace the shell (sign-in rejected, sign-in failed, not
 * found, app error) use StatusPage instead.
 */
export function InShellStatus({ title, children, action }: InShellStatusProps) {
  return (
    <Box>
      <Typography variant="h6" component="h1" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph={Boolean(action)}>
        {children}
      </Typography>
      {action}
    </Box>
  );
}
